<div class="d-inline-flex">
  <ncp-button
    #addPhysicalFindingButton
    [options]="btnPFOptions()"
  >
    <img
      [ngSrc]="assets.healthIcons.svg.outline.devices.blood_pressure_monitor.src"
      width="18"
      height="18"
      alt="Add Physical Finding"
      class="healthIcon"
    />
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="physical_findings_form"
      name="physical_findings_form"
      [formGroup]="form"
      #pfFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-input #systolic [(options)]="systolicOptions" />
      <ncp-input #diastolic [(options)]="diastolicOptions" />
      <ncp-date #measurementDate [(options)]="measurementDateOptions" />
    </form>
  </ncp-modal>
</div>
